import ChangeOwnerModal from './ChangeOwnerModal'

export default ChangeOwnerModal
